import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = 'University Admissions Help | Admissions Express USA',
  description = 'We assist United States students with university admissions, English tests, and personalized guidance for studying. Expert support for your academic journey.',
  keywords = 'university admissions, usa students, admissions help, study abroad, English tests, academic guidance',
  canonicalUrl = 'https://admissionsexpress.com',
  ogImage = '/og-image.png',
  ogType = 'website',
  twitterCard = 'summary_large_image'
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Admissions Express" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Schema.org markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Admissions Express",
          "url": "https://admissionsexpress.com",
          "logo": "https://admissionsexpress.com/aelogo.png",
          "sameAs": [
            "https://www.facebook.com/admissionsexpress",
            "https://twitter.com/admissionsexp",
            "https://www.linkedin.com/company/admissionsexpress",
            "https://www.youtube.com/@xvantechLLC-arizona"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+1-623-212-3213",
            "contactType": "customer service"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
